import KendoDateinputsInstaller from './kendo-dateinputs-installer'
import KendoCalendar from './KendoCalendar'
import KendoDateInput from './KendoDateInput'
import KendoDatePicker from './KendoDatePicker'
import KendoDateRangePicker from './KendoDateRangePicker'
import KendoDateTimePicker from './KendoDateTimePicker'
import KendoTimePicker from './KendoTimePicker'
import KendoMultiViewCalendar from './KendoMultiViewCalendar'

export { KendoDateinputsInstaller, KendoDateinputsInstaller as DateinputsInstaller, KendoCalendar, KendoCalendar as Calendar, KendoDateInput, KendoDateInput as DateInput, KendoDatePicker, KendoDatePicker as DatePicker, KendoDateTimePicker, KendoDateTimePicker as DateTimePicker, KendoTimePicker, KendoTimePicker as TimePicker, KendoMultiViewCalendar as MultiViewCalendar, KendoMultiViewCalendar, KendoDateRangePicker as DateRangePicker, KendoDateRangePicker }


// WEBPACK FOOTER //
// ./packages/kendo-dateinputs-vue-wrapper/src/index.js